import * as graphql from '@treams/treams-network';

import {
	FeedbackResultsLayout,
	FeedbackResultsLayoutSkeleton,
} from './components/FeedbackResultsLayout';

export default function FeedbackRequest(props: { id: string }) {
	const query = graphql.useFeedbackResultsQuery({ variables: { id: props.id } });

	if (!query.data) {
		return <FeedbackResultsLayoutSkeleton />;
	}

	return <FeedbackResultsLayout request={query.data.feedbackRequest as graphql.FeedbackRequest} />;
}
